<template lang="pug">
.fights
  //- ============ CABEÇALHO ============
  header.fights__hero
    .fights__hero-grid
    .fights__hero-glow.fights__hero-glow--blue
    .fights__hero-glow.fights__hero-glow--red
    .fights__hero-inner
      p.fights__eyebrow
        span.fights__eyebrow-pip
        | Programação de combates
      h1.fights__title Próximas Lutas
      p.fights__sub Acompanhe a ordem dos combates, arenas e horários. Quando for sua vez, entre na luta direto por aqui.

  //- ============ CONTEÚDO ============
  .fights__wrap
    .fights__toolbar(v-if="takeCanEditFights")
      .fights__toolbar-info(v-if="!editTable")
        FontAwesomeIcon.fights__toolbar-ic(:icon="['fas','arrows-alt']")
        span Reorganize a fila de combates e ajuste horários.
      .fights__toolbar-actions
        button.btn.btn--ghost-dark(
          v-if="!editTable && isStaffRole && nextPendingIndex !== -1"
          @click="doOpenReschedule"
        )
          FontAwesomeIcon.btn__ic(:icon="['fas','clock']")
          span Reagendar tudo
        button.btn.btn--ghost-dark(
          v-if="!editTable"
          @click="doSetTableEdit(true)"
        )
          FontAwesomeIcon.btn__ic(:icon="['fas','edit']")
          span Alterar ordem
        button.btn.btn--ghost-dark(
          v-if="editTable"
          @click="doSaveTable(false)"
        )
          FontAwesomeIcon.btn__ic(:icon="['fas','times']")
          span Cancelar
        button.btn.btn--solid(
          v-if="editTable"
          @click="doSaveTable(true)"
        )
          FontAwesomeIcon.btn__ic(:icon="['fas','check']")
          span Salvar alterações

    //- ----- Estado vazio -----
    .fights__empty(v-if="!fights.length")
      FontAwesomeIcon.fights__empty-ic(:icon="['fas','flag-checkered']")
      strong Nenhuma luta na fila
      span As lutas aparecem aqui assim que a chave do evento for gerada.

    //- ===================================================================
    //- MODO EDIÇÃO (juízes): fila completa, sem busca, com reordenação
    //- ===================================================================
    template(v-else-if="editTable")
      .fights__rows
        article.frow.frow--edit(
          v-for="item in indexedFights"
          :key="item.fight.id"
        )
          span.frow__order # {{ doPad(item.index + 1) }}
          .frow__match
            span.frow__robot.frow__robot--blue {{ item.fight.blue_side || 'A definir' }}
            span.frow__x ×
            span.frow__robot.frow__robot--red {{ item.fight.red_side || 'A definir' }}
          .frow__tags
            span.frow__tag(v-if="item.fight.category") {{ item.fight.category }}
            span.frow__tag.frow__tag--muted {{ item.fight.arena_name || item.fight.arena_id || 'Arena a definir' }}
            span.frow__tag.frow__tag--time
              FontAwesomeIcon.frow__tag-ic(:icon="['far','clock']")
              | {{ doFightClock(item.fight) || 'A definir' }}
          .frow__edit
            button.frow__edit-btn(title="Ajustar horário" @click="doEditFight(item.index)")
              FontAwesomeIcon(:icon="['fas','clock']")
            button.frow__edit-btn(title="Atrasar desta luta para baixo (cascata)" @click="doCascadeFight(item.index)")
              FontAwesomeIcon(:icon="['fas','angle-double-down']")
            button.frow__edit-btn(v-if="item.index > 0" title="Adiantar uma posição" @click="doMoveFight(item.index, -1)")
              FontAwesomeIcon(:icon="['fas','chevron-up']")
            button.frow__edit-btn(v-if="item.index + 1 !== fights.length" title="Adiar uma posição" @click="doMoveFight(item.index, 1)")
              FontAwesomeIcon(:icon="['fas','chevron-down']")

    //- ===================================================================
    //- MODO NORMAL (público + juízes): destaque + lista compacta
    //- ===================================================================
    template(v-else)
      //- ----- Destaque: acontecendo agora / a seguir -----
      section.fights__spotlight(v-if="liveFights.length || nextFights.length")
        template(v-if="liveFights.length")
          h2.fights__heading
            span.fights__heading-live
              span.fights__heading-pulse
              | Acontecendo agora
          .fights__cards
            article.fcard.fcard--live(v-for="item in liveFights" :key="'live-' + item.fight.id")
              .fcard__head
                span.fcard__order
                  small Luta
                  strong {{ doPad(item.index + 1) }}
                span.fcard__status.is-live Ao vivo
              .fcard__match
                .fcard__side.fcard__side--blue
                  span.fcard__side-tag
                    FontAwesomeIcon.fcard__side-ic(:icon="['fas','robot']")
                    | Lado Azul
                  span.fcard__side-name {{ item.fight.blue_side || 'A definir' }}
                .fcard__vs
                  span VS
                .fcard__side.fcard__side--red
                  span.fcard__side-tag
                    FontAwesomeIcon.fcard__side-ic(:icon="['fas','robot']")
                    | Lado Vermelho
                  span.fcard__side-name {{ item.fight.red_side || 'A definir' }}
              .fcard__meta
                span.fcard__chip(v-if="item.fight.category")
                  FontAwesomeIcon.fcard__chip-ic(:icon="['fas','layer-group']")
                  | {{ item.fight.category }}
                span.fcard__chip
                  FontAwesomeIcon.fcard__chip-ic(:icon="['fas','map-marker-alt']")
                  | {{ item.fight.arena_name || item.fight.arena_id || 'Arena a definir' }}
                span.fcard__chip
                  FontAwesomeIcon.fcard__chip-ic(:icon="['far','clock']")
                  | {{ doFightClock(item.fight) || 'A definir' }}
              .fcard__action(v-if="doTakeTableText(item.index)")
                button.btn.btn--solid.fcard__action-btn(@click="doStartFight(item.index)")
                  FontAwesomeIcon.btn__ic(:icon="['fas','bolt']")
                  span {{ doTakeTableText(item.index) }}

        template(v-if="nextFights.length")
          h2.fights__heading A seguir
          .fights__cards
            article.fcard(v-for="item in nextFights" :key="'next-' + item.fight.id")
              .fcard__head
                span.fcard__order
                  small Luta
                  strong {{ doPad(item.index + 1) }}
                span.fcard__status(:class="doFightStatus(item.fight).cls") {{ doFightStatus(item.fight).label }}
              .fcard__match
                .fcard__side.fcard__side--blue
                  span.fcard__side-tag
                    FontAwesomeIcon.fcard__side-ic(:icon="['fas','robot']")
                    | Lado Azul
                  span.fcard__side-name {{ item.fight.blue_side || 'A definir' }}
                .fcard__vs
                  span VS
                .fcard__side.fcard__side--red
                  span.fcard__side-tag
                    FontAwesomeIcon.fcard__side-ic(:icon="['fas','robot']")
                    | Lado Vermelho
                  span.fcard__side-name {{ item.fight.red_side || 'A definir' }}
              .fcard__meta
                span.fcard__chip(v-if="item.fight.category")
                  FontAwesomeIcon.fcard__chip-ic(:icon="['fas','layer-group']")
                  | {{ item.fight.category }}
                span.fcard__chip
                  FontAwesomeIcon.fcard__chip-ic(:icon="['fas','map-marker-alt']")
                  | {{ item.fight.arena_name || item.fight.arena_id || 'Arena a definir' }}
                span.fcard__chip
                  FontAwesomeIcon.fcard__chip-ic(:icon="['far','clock']")
                  | {{ doFightClock(item.fight) || 'A definir' }}
              .fcard__action(v-if="doTakeTableText(item.index)")
                button.btn.btn--solid.fcard__action-btn(@click="doStartFight(item.index)")
                  FontAwesomeIcon.btn__ic(:icon="['fas','bolt']")
                  span {{ doTakeTableText(item.index) }}

      //- ----- Lista completa: busca + filtros + linhas compactas -----
      section.fights__schedule
        .fights__schedule-head
          h2.fights__heading Agenda completa
          span.fights__live-tag
            span.fights__live-dot
            | Atualiza automaticamente

        .fights__controls
          .fights__search
            FontAwesomeIcon.fights__search-ic(:icon="['fas','search']")
            input.fights__search-input(
              type="text"
              v-model="search"
              placeholder="Busque por robô (lado azul ou vermelho)"
            )
            button.fights__search-clear(v-if="search" @click="search = ''" aria-label="Limpar")
              FontAwesomeIcon(:icon="['fas','times']")
          select.fights__select(v-if="categoryOptions.length > 1" v-model="categoryFilter")
            option(value="") Todas as categorias
            option(v-for="c in categoryOptions" :key="c" :value="c") {{ c }}
          select.fights__select(v-if="arenaOptions.length > 1" v-model="arenaFilter")
            option(value="") Todas as arenas
            option(v-for="a in arenaOptions" :key="a" :value="a") {{ a }}

        p.fights__count
          | {{ filteredFights.length }}
          template(v-if="filteredFights.length !== fights.length")  de {{ fights.length }}
          |  {{ filteredFights.length === 1 ? 'luta' : 'lutas' }}

        .fights__rows(v-if="filteredFights.length")
          template(v-for="(item, i) in filteredFights")
            .flunch(v-if="showLunchBefore(i)" :key="'lunch-' + item.fight.id")
              span.flunch__ic 🍽
              span.flunch__txt Intervalo de almoço
              span.flunch__time {{ lunchRange }}
            article.frow(
              :key="item.fight.id"
              :class="{ 'frow--live': item.fight.round_judge_id && !item.fight.ended_at, 'frow--done': item.fight.ended_at }"
            )
              span.frow__order # {{ doPad(item.index + 1) }}
              .frow__match
                span.frow__robot.frow__robot--blue {{ item.fight.blue_side || 'A definir' }}
                span.frow__x ×
                span.frow__robot.frow__robot--red {{ item.fight.red_side || 'A definir' }}
              .frow__tags
                span.frow__tag(v-if="item.fight.category") {{ item.fight.category }}
                span.frow__tag.frow__tag--muted {{ item.fight.arena_name || item.fight.arena_id || 'Arena a definir' }}
                span.frow__tag.frow__tag--time
                  FontAwesomeIcon.frow__tag-ic(:icon="['far','clock']")
                  | {{ doFightClock(item.fight) || 'A definir' }}
              span.frow__status(:class="doFightStatus(item.fight).cls") {{ doFightStatus(item.fight).label }}
              .frow__action(v-if="doTakeTableText(item.index)")
                button.btn.btn--solid.btn--sm(@click="doStartFight(item.index)")
                  FontAwesomeIcon.btn__ic(:icon="['fas','bolt']")
                  span {{ doTakeTableText(item.index) }}

        .fights__empty-filter(v-else)
          FontAwesomeIcon.fights__empty-filter-ic(:icon="['fas','search']")
          span Nenhuma luta encontrada com esses filtros.
          button.btn.btn--ghost-dark.btn--sm(@click="doClearFilters")
            span Limpar filtros

  Modal(
    :visible="showModal"
    @close="doSetModalVisibility"
  )
    .modal-content(
      v-if="step === 0"
    )
      span.modal-content__title Novo horário da luta

      label.modal-content__field
        span.modal-content__field-label Horário
        input.modal-content__input(
          type="time"
          id="TimeFight"
          name="Time"
          :min="takeMinTime"
          :max="takeMaxTime"
          v-model="fightTime"
          required
        )

      label.modal-content__field
        span.modal-content__field-label Data
        input.modal-content__input(
          type="date"
          id="DateFight"
          name="Date"
          :min="takeMinDate"
          :max="takeMaxDate"
          v-model="fightDate"
          required
        )

      button.btn.btn--solid.modal-content__confirm(@click="doSetModalVisibility(true)")
        span Confirmar

    .modal-content(
      v-if="step === 4"
    )
      span.modal-content__title Atrasar em cascata
      p.modal-content__note A luta selecionada e todas as seguintes na fila são adiadas nos minutos abaixo (lutas sem horário ficam paradas). A mudança só é gravada no Salvar alterações — dá para revisar ou cancelar antes.

      label.modal-content__field
        span.modal-content__field-label Minutos de atraso
        input.modal-content__input(
          type="number"
          id="CascadeMinutes"
          name="CascadeMinutes"
          min="1"
          max="600"
          step="5"
          v-model.number="cascadeMinutes"
          required
        )

      p.modal-content__note.modal-content__note--strong(v-if="cascadePreview") {{ cascadePreview }}

      button.btn.btn--solid.modal-content__confirm(@click="doSetModalVisibility(true)")
        span Confirmar

    .modal-content(
      v-if="step === 3"
    )
      span.modal-content__title Reagendar lutas pendentes
      p.modal-content__note A próxima luta passa para o novo horário e todas as seguintes acompanham (em todas as arenas do evento), mantendo os intervalos entre elas. O intervalo de almoço se move junto. Lutas em andamento não se movem.

      label.modal-content__field
        span.modal-content__field-label Novo horário da próxima luta
        input.modal-content__input(
          type="time"
          id="TimeReschedule"
          name="TimeReschedule"
          v-model="fightTime"
          required
        )

      label.modal-content__field
        span.modal-content__field-label Data
        input.modal-content__input(
          type="date"
          id="DateReschedule"
          name="DateReschedule"
          v-model="fightDate"
          required
        )

      p.modal-content__note.modal-content__note--strong(v-if="reschedulePreview") {{ reschedulePreview }}

      button.btn.btn--solid.modal-content__confirm(@click="doSetModalVisibility(true)")
        span Confirmar

</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import {
  Modal
} from '@/components/molecules'

const REFRESH_MS = 20000

export default {
  name: 'Fights',
  props: {
    // propName: {
    //   type: String,
    //   required: false,
    //   validator: (value) => {
    //     return value
    //   },
    //   default: () => ''
    // }
  },
  data: () => ({
    showModal: false,
    step: 0,
    selectedItemIndex: 0,
    fights: [],
    editTable: false,
    changeNextFights: true,
    cascadeMinutes: 10, // minutos do "Atrasar em cascata" (modo edição)
    fightDate: '',
    fightTime: '',
    amountOfIcons: [],
    search: '',
    categoryFilter: '',
    arenaFilter: '',
    refreshTimer: null,
    lunch: null, // intervalo de almoço do evento (null = sem intervalo)
    rescheduleAnchorId: 0 // luta âncora do "Reagendar tudo" (congelada ao abrir o modal)
  }),
  components: {
    Modal
  },
  created () {
    this.setEvents().then(() => {
      this.setFights({ event_id: this.getCurrentEventId }).then((res) => {
        this.fights = JSON.parse(JSON.stringify(this.getFights))
      })
      this.loadLunch()
    })
  },
  mounted () {
    // Auto-refresh silencioso da agenda (não pisca o overlay de loading).
    // Pausa durante edição de fila ou modal aberto p/ não descartar mudanças.
    this.refreshTimer = setInterval(() => {
      if (this.editTable || this.showModal || !this.getCurrentEventId) return
      this.setFights({ event_id: this.getCurrentEventId, silent: true }).then(() => {
        if (!this.editTable && !this.showModal) {
          this.fights = JSON.parse(JSON.stringify(this.getFights))
        }
      })
    }, REFRESH_MS)
  },
  beforeDestroy () {
    if (this.refreshTimer) clearInterval(this.refreshTimer)
  },
  computed: {
    ...mapGetters('users', [
      'getUser'
    ]),
    ...mapGetters('fights', [
      'getFights'
    ]),
    ...mapGetters('events', [
      'getCurrentEventId'
    ]),
    // Cada luta com seu índice real na fila (preservado mesmo após busca/filtro,
    // porque toda ação — iniciar/entrar/reordenar — opera por índice em `fights`).
    indexedFights () {
      return this.fights.map((fight, index) => ({ fight, index }))
    },
    liveFights () {
      return this.indexedFights.filter(({ fight }) => fight.round_judge_id && !fight.ended_at)
    },
    nextFights () {
      return this.indexedFights
        .filter(({ fight }) => !fight.ended_at && !fight.round_judge_id)
        .slice(0, 2)
    },
    categoryOptions () {
      const set = []
      this.fights.forEach(f => {
        if (f.category && !set.includes(f.category)) set.push(f.category)
      })
      return set
    },
    arenaOptions () {
      const set = []
      this.fights.forEach(f => {
        const a = f.arena_name || f.arena_id
        if (a && !set.includes(a)) set.push(a)
      })
      return set
    },
    filteredFights () {
      const query = this.search.trim().toLowerCase()
      return this.indexedFights.filter(({ fight }) => {
        if (this.categoryFilter && fight.category !== this.categoryFilter) return false
        if (this.arenaFilter && (fight.arena_name || fight.arena_id) !== this.arenaFilter) return false
        if (query) {
          const haystack = `${fight.blue_side || ''} ${fight.red_side || ''}`.toLowerCase()
          if (!haystack.includes(query)) return false
        }
        return true
      })
    },
    // Admin (1) acumula todas as funções (é o papel máximo), então entra em
    // qualquer uma das checagens abaixo junto com o papel específico.
    takeRoles () {
      return (this.getUser && this.getUser.roles) || []
    },
    isRoundJudgeRole () {
      return this.takeRoles.includes(4) || this.takeRoles.includes(1)
    },
    // Staff do evento (Admin/Organizador) — únicos que veem o "Reagendar tudo",
    // mesmo gate do backend (reschedule_pending exige 1/6).
    isStaffRole () {
      return this.takeRoles.includes(1) || this.takeRoles.includes(6)
    },
    // Próxima luta pendente (não iniciada, COM horário) — a âncora do "Reagendar
    // tudo". Sem horário não há delta possível (o backend também a ignoraria).
    nextPendingIndex () {
      return this.fights.findIndex(f => !f.ended_at && !f.round_judge_id && f.start_at)
    },
    // Preview do reagendamento: delta e alcance, antes de confirmar.
    reschedulePreview () {
      const i = this.nextPendingIndex
      if (i === -1 || !this.fightTime || !this.fightDate) return ''
      const anchor = this.fights[i]
      if (!anchor.start_at) return ''
      const novo = new Date(`${this.fightDate}T${this.fightTime}:00.000Z`)
      const atual = new Date(anchor.start_at)
      if (isNaN(novo.getTime()) || isNaN(atual.getTime())) return ''
      const delta = Math.round((novo.getTime() - atual.getTime()) / 60000)
      const naFila = this.fights.filter(f => !f.ended_at && !f.round_judge_id).length
      const sinal = delta >= 0 ? '+' : '−'
      return `${naFila} lutas da fila deslocam ${sinal}${Math.abs(delta)} min (rodadas futuras e almoço acompanham).`
    },
    isCombatJudgeRole () {
      return this.takeRoles.includes(3) || this.takeRoles.includes(1)
    },
    // —— intervalo de almoço (exibido na agenda) ——
    lunchEndMs () {
      if (!this.lunch) return 0
      const d = new Date(this.lunch.start_at)
      return isNaN(d.getTime()) ? 0 : d.getTime() + (this.lunch.minutes || 0) * 60000
    },
    lunchRange () {
      if (!this.lunch) return ''
      const ini = new Date(this.lunch.start_at)
      if (isNaN(ini.getTime())) return ''
      const fim = new Date(ini.getTime() + (this.lunch.minutes || 0) * 60000)
      // horários são wall-clock rotulado Z (mesma convenção do resto da agenda)
      const hh = d => `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`
      return `${hh(ini)} às ${hh(fim)}`
    },
    takeCanEditFights () {
      const roles = this.takeRoles
      return Array.isArray(roles) && (roles.includes(4) || roles.includes(5) || roles.includes(1) || roles.includes(6))
    },
    // Preview da cascata: quantas lutas se movem a partir da selecionada.
    cascadePreview () {
      const min = parseInt(this.cascadeMinutes, 10)
      if (!min || min < 1) return ''
      const alvo = this.fights.slice(this.selectedItemIndex).filter(f => f.start_at).length
      if (!alvo) return 'Nenhuma das lutas alcançadas tem horário definido.'
      return `${alvo} ${alvo === 1 ? 'luta desloca' : 'lutas deslocam'} +${min} min (da luta #${this.doPad(this.selectedItemIndex + 1)} em diante).`
    },
    takeMinTime () {
      const date = new Date()
      let hours = date.getHours()
      let minutes = date.getMinutes() + 2
      if (minutes < 10) {
        minutes = `0${minutes}`
      }
      if (minutes > 59) {
        minutes = '00'
      }
      if (hours < 10) {
        hours = `0${hours}`
      }
      return `${hours}:${minutes}`
    },
    takeMaxTime () {
      return '24:00'
    },
    takeMinDate () {
      let today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1
      const yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    takeMaxDate () {
      const date = new Date()
      const day = date.getDate()
      const month = date.getMonth() + 6
      const year = date.getFullYear()

      return `${year}-${month}-${day}`
    }
  },
  methods: {
    ...mapActions('fights', [
      'setFights',
      'setEnterFight',
      'setInitFight',
      'setEnterRoundJudgeFight',
      'setChangeFightsTime',
      'setReschedulePending',
      'fetchEventLunch'
    ]),
    ...mapActions('events', [
      'setEvents'
    ]),
    doPad (n) {
      return String(n).padStart(2, '0')
    },
    doClearFilters () {
      this.search = ''
      this.categoryFilter = ''
      this.arenaFilter = ''
    },
    doFightStatus (fight) {
      if (fight.ended_at) {
        return { label: 'Encerrada', cls: 'is-done' }
      }
      if (fight.round_judge_id) {
        return { label: 'Em andamento', cls: 'is-live' }
      }
      if (!fight.red_side || !fight.blue_side) {
        return { label: 'Aguardando robôs', cls: 'is-wait' }
      }
      return { label: 'Na fila', cls: 'is-queued' }
    },
    loadLunch () {
      if (!this.getCurrentEventId) { this.lunch = null; return }
      this.fetchEventLunch({ event_id: this.getCurrentEventId }).then(res => {
        this.lunch = (res && res.enabled) ? res : null
      })
    },
    // Mostra a faixa de almoço ANTES da primeira luta que começa depois do
    // intervalo (só se houver luta antes dele na lista exibida).
    showLunchBefore (i) {
      if (!this.lunch || i === 0) return false
      const fim = this.lunchEndMs
      const atual = this.fightMs(this.filteredFights[i].fight)
      const anterior = this.fightMs(this.filteredFights[i - 1].fight)
      if (atual == null || anterior == null) return false
      return anterior < fim && atual >= fim
    },
    fightMs (fight) {
      if (!fight || !fight.start_at) return null
      const d = new Date(fight.start_at)
      return isNaN(d.getTime()) ? null : d.getTime()
    },
    doFightClock (fight) {
      if (!fight.start_at) {
        return ''
      }
      const time = fight.start_at.split('T')[1]
      return time ? time.slice(0, 5) : ''
    },
    doFormatDateTime (value) {
      if (!value) {
        return 'Sem horário definido'
      }
      const y = value.split('-')[0]
      const mm = value.split('-')[1]
      const d = value.split('-')[2].split('T')[0]
      const date = d + '/' + mm + '/' + y
      const h = value.split('T')[1].split(':')[0]
      const min = value.split('T')[1].split(':')[1]
      const hour = h + ':' + min
      const final = hour + ' - ' + date
      return final
    },
    doTakeTableText (rowIndex) {
      if (this.fights.length) {
        const f = this.fights[rowIndex]
        if (!f.red_side || !f.blue_side) {
          return '' // só lutas com os dois robôs definidos são iniciáveis/acionáveis
        }
        const roles = this.takeRoles
        if (roles.includes(0)) {
          return ''
        } else if (this.isRoundJudgeRole && this.fights[rowIndex].round_judge_id && this.fights[rowIndex].round_judge_id === this.getUser.id && !this.fights[rowIndex].ended_at) {
          return 'Continuar' // juiz de round (ou admin)
        } else if (this.isRoundJudgeRole && !this.fights[rowIndex].round_judge_id) {
          return 'Iniciar' // juiz de round (ou admin)
        } else if (this.isRoundJudgeRole && this.fights[rowIndex].round_judge_id && this.fights[rowIndex].round_judge_id !== this.getUser.id) {
          return 'Entrar' // juiz de round (ou admin)
        } else if (this.isCombatJudgeRole && this.fights[rowIndex].round_judge_id) {
          return 'Entrar' // juiz de combate (ou admin)
        }
      }
      return ''
    },
    doEditFight (e) {
      this.step = 0
      this.selectedItemIndex = e
      const final = this.doFormatDateTime(this.fights[e].start_at).split(' - ')[1]
      let date = final.split('/')
      date = date[2] + '-' + date[1] + '-' + date[0]
      this.fightDate = date
      this.fightTime = this.takeMinTime
      this.showModal = true
    },
    // Setas do modo edição: movem a luta UMA posição na hora (trocando horário
    // e lugar com a vizinha), sem modal — persiste no "Salvar alterações".
    doMoveFight (index, dir) {
      const fights = this.fights
      const alvo = index + dir
      if (alvo < 0 || alvo >= fights.length) {
        return
      }
      const atual = fights[index]
      const vizinho = fights[alvo]
      const meio = atual.start_at
      atual.start_at = vizinho.start_at
      vizinho.start_at = meio
      fights[index] = vizinho
      fights[alvo] = atual
      this.fights = [...fights] // Vue 2: atribuição por índice não é reativa
    },
    doCascadeFight (e) {
      this.step = 4
      this.selectedItemIndex = e
      this.cascadeMinutes = 10
      this.showModal = true
    },
    doOpenReschedule () {
      const i = this.nextPendingIndex
      if (i === -1) return
      // Congela a âncora QUE O ADMIN ESTÁ VENDO — vai no payload pro backend
      // calcular o delta a partir dela (não da 1ª pendente que ele achar).
      this.rescheduleAnchorId = this.fights[i].id
      // pré-preenche com o horário atual da próxima luta (wall-clock rotulado Z)
      const start = this.fights[i].start_at || ''
      this.fightDate = start.split('T')[0] || ''
      this.fightTime = (start.split('T')[1] || '').slice(0, 5)
      this.step = 3
      this.showModal = true
    },
    doSetModalVisibility (e) {
      this.showModal = false
      const fights = this.fights
      if (!e) {
        return
      }
      if (this.step === 3) {
        // Reagendar tudo: vai direto ao servidor (não passa pelo "Salvar alterações")
        if (!this.fightDate || !this.fightTime) {
          window.alert('Preencha data e horário para reagendar.')
          return
        }
        this.setReschedulePending({
          event_id: this.getCurrentEventId,
          anchor_fight_id: this.rescheduleAnchorId,
          new_time: `${this.fightDate}T${this.fightTime}:00.000Z`
        }).then(res => {
          if (!res || res.error) {
            window.alert((res && res.error) || 'Não foi possível reagendar. Confira o horário e tente de novo.')
            return
          }
          this.setFights({ event_id: this.getCurrentEventId }).then(() => {
            this.fights = JSON.parse(JSON.stringify(this.getFights))
          })
          this.loadLunch() // o almoço deslocou junto no servidor
        })
        return
      }
      if (this.step === 0) {
        this.fights[this.selectedItemIndex].start_at = `${this.fightDate}T${this.fightTime}:00.000Z`
      } else if (this.step === 4) {
        // Cascata: adia a luta selecionada e TODAS as seguintes da fila em N
        // minutos (as sem horário ficam paradas). Mexe só na cópia local — a
        // persistência é o "Salvar alterações" (change_fight_time), então dá
        // para revisar e cancelar. Diferente do "Reagendar tudo" (step 3), que
        // ancora na próxima pendente e vai direto ao servidor.
        const min = parseInt(this.cascadeMinutes, 10)
        if (!min || min < 1) {
          window.alert('Informe quantos minutos de atraso aplicar.')
          return
        }
        for (let i = this.selectedItemIndex; i < fights.length; i++) {
          if (!fights[i].start_at) continue
          const d = new Date(fights[i].start_at)
          if (isNaN(d.getTime())) continue
          fights[i].start_at = new Date(d.getTime() + min * 60000).toISOString()
        }
      }
      this.fights = [...fights]
    },
    doChangeNextFights (e) {
      this.changeNextFights = e
    },
    doSetTableEdit (e) {
      this.editTable = e
    },
    doSaveTable (e) {
      this.editTable = false
      if (e) {
        const newFights = this.fights.filter((fight, index) =>
          fight.start_at !== this.getFights.find(internalFight => internalFight.id === fight.id).start_at
        ).map(fight => {
          return { fight_id: fight.id, new_time: fight.start_at }
        })
        this.setChangeFightsTime(newFights).then(
          resp => this.setFights({ event_id: this.getCurrentEventId }).then(resp => {
            this.fights = JSON.parse(JSON.stringify(this.getFights))
          })
        )
        return
      }
      this.fights = JSON.parse(JSON.stringify(this.getFights))
    },
    async doStartFight (rowIndex) {
      const f = this.fights[rowIndex]
      if (!f.red_side || !f.blue_side) {
        return // luta sem os dois robôs definidos não pode ser iniciada/acessada
      }
      const payload = { judge_id: this.getUser.id, fight_id: f.id }
      let res
      // aguarda a action carregar a luta ANTES de navegar — senão a tela de
      // julgamento monta com currentFight vazio (cai no estado "sem luta")
      if (this.isRoundJudgeRole && !f.round_judge_id) {
        res = await this.setInitFight(payload)
      } else if (this.isCombatJudgeRole) {
        // juiz de combate (3) ou admin (1): vai pontuar — enter_fight garante as
        // linhas de score dele (inclusive o juiz acumulado voltando à própria luta)
        res = await this.setEnterFight(payload)
      } else {
        // juiz de round (4) puro em luta que não é dele só acompanha: entrada
        // read-only via enter_fight_judge. Cair no enter_fight aqui criava pares
        // de linhas NULL em fights_scores que travavam o placar dos 3 juízes
        // (Copa Redelease, lutas 965 e 1102).
        res = await this.setEnterRoundJudgeFight(payload)
      }
      if (Array.isArray(res) && res.length) {
        this.$router.push('CurrentFight')
      } else {
        window.alert('Não foi possível abrir a luta agora. Atualize a agenda e tente novamente.')
      }
    }
  },
  watch: {
    getCurrentEventId (newId) {
      if (newId) {
        this.setFights({ event_id: newId }).then(() => {
          this.fights = JSON.parse(JSON.stringify(this.getFights))
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$red-dark: #B0231F
$green: #2E9E4F
$green-dark: #1F7C3C
$ink: #0B0E14
$paper: #FFFFFF
$muted: #5C6673
$line: rgba(11, 14, 20, 0.10)
$mist: #EEF1F6
$page: #F2F4F8

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.fights
  color: $ink
  background: $page
  min-height: calc(100vh - 64px)
  font-family: Lato, sans-serif

  *
    box-sizing: border-box

  // ---------- CABEÇALHO ----------
  &__hero
    position: relative
    overflow: hidden
    isolation: isolate
    padding: 54px 0 60px
    background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
    color: #fff

  &__hero-grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
    background-size: 42px 42px
    mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    z-index: -2

  &__hero-glow
    position: absolute
    width: 360px
    height: 360px
    border-radius: 50%
    filter: blur(110px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -150px
      left: -90px
    &--red
      background: $red
      bottom: -180px
      right: -80px

  &__hero-inner
    position: relative
    max-width: 1040px
    margin: 0 auto
    padding: 0 24px
    > *
      animation: ff-rise .6s cubic-bezier(.2, .7, .2, 1) both
    .fights__eyebrow
      animation-delay: .04s
    .fights__title
      animation-delay: .10s
    .fights__sub
      animation-delay: .16s

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.7)
    margin: 0 0 14px

  &__eyebrow-pip
    width: 8px
    height: 8px
    border-radius: 50%
    background: linear-gradient(135deg, #5AA0FF, $red)
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.18)

  &__title
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(40px, 6vw, 66px)
    line-height: 0.94
    letter-spacing: -0.015em
    margin: 0

  &__sub
    font-size: 17px
    color: rgba(255, 255, 255, 0.74)
    margin: 16px 0 0
    max-width: 560px

  // ---------- CONTEÚDO ----------
  &__wrap
    max-width: 1040px
    margin: 0 auto
    // respiro no topo: sem ele, o primeiro bloco (título, toolbar ou estado
    // vazio) encostava/entrava no hero escuro e ficava ilegível
    padding: 28px 24px 72px

  // ---------- TOOLBAR ----------
  &__toolbar
    margin-top: -28px
    position: relative
    z-index: 1
    display: flex
    flex-wrap: wrap
    align-items: center
    justify-content: space-between
    gap: 16px
    padding: 18px 22px
    background: $paper
    border: 1px solid $line
    border-radius: 14px
    box-shadow: 0 22px 50px rgba(11, 14, 20, 0.10)
    margin-bottom: 26px
    animation: ff-rise .55s cubic-bezier(.2, .7, .2, 1) both
    animation-delay: .2s

  &__toolbar-info
    display: inline-flex
    align-items: center
    gap: 10px
    font-size: 14px
    color: $muted

  &__toolbar-ic
    color: $blue
    font-size: 15px

  &__toolbar-actions
    display: inline-flex
    flex-wrap: wrap
    gap: 10px
    margin-left: auto

  // ---------- ESTADO VAZIO ----------
  &__empty
    margin-top: -28px
    position: relative
    z-index: 1
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
    gap: 10px
    padding: 56px 28px
    background: $paper
    border: 1px dashed rgba(11, 14, 20, 0.18)
    border-radius: 16px
    box-shadow: 0 22px 50px rgba(11, 14, 20, 0.08)
    &-ic
      font-size: 40px
      color: $blue
      margin-bottom: 4px
    strong
      font-family: $display
      text-transform: uppercase
      font-size: 24px
    span
      color: $muted
      font-size: 15px
      max-width: 360px

  // ---------- TÍTULOS DE SEÇÃO ----------
  &__heading
    font-family: $display
    text-transform: uppercase
    font-weight: 700
    font-size: 22px
    letter-spacing: 0.01em
    margin: 0 0 14px
    color: $ink

  &__heading-live
    display: inline-flex
    align-items: center
    gap: 10px
    color: $green-dark

  &__heading-pulse
    width: 11px
    height: 11px
    border-radius: 50%
    background: $green
    box-shadow: 0 0 0 0 rgba(46, 158, 79, 0.55)
    animation: ff-pulse 1.6s ease-out infinite

  // ---------- INTERVALO DE ALMOÇO NA AGENDA ----------
  .flunch
    display: flex
    align-items: center
    gap: 12px
    margin: 14px 0
    padding: 12px 18px
    border-radius: 12px
    border: 1px dashed rgba(249, 168, 37, 0.55)
    background: linear-gradient(135deg, rgba(249, 168, 37, 0.10), rgba(249, 168, 37, 0.03))
    &__ic
      font-size: 18px
    &__txt
      font-family: $display
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.04em
      font-size: 15px
      color: #8D6E00
    &__time
      margin-left: auto
      font-family: $mono
      font-size: 12px
      font-weight: 700
      color: #8D6E00

  // ---------- DESTAQUE (cards grandes) ----------
  &__spotlight
    // Era -28px para sobrepor o hero. Só que o primeiro filho costuma ser um
    // TÍTULO (cor $ink) — quando não há luta ao vivo, "A seguir" caía dentro do
    // fundo escuro do hero e sumia. O respiro agora vem do padding do __wrap.
    position: relative
    z-index: 1
    margin-bottom: 36px
    & > .fights__heading:not(:first-child)
      margin-top: 28px

  &__cards
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr))
    gap: 18px

  // ---------- AGENDA COMPLETA ----------
  &__schedule-head
    display: flex
    align-items: center
    justify-content: space-between
    flex-wrap: wrap
    gap: 10px

  &__live-tag
    display: inline-flex
    align-items: center
    gap: 8px
    font-family: $mono
    font-size: 11px
    letter-spacing: 0.06em
    text-transform: uppercase
    color: $muted

  &__live-dot
    width: 8px
    height: 8px
    border-radius: 50%
    background: $green
    box-shadow: 0 0 0 0 rgba(46, 158, 79, 0.5)
    animation: ff-pulse 1.6s ease-out infinite

  &__controls
    display: flex
    flex-wrap: wrap
    gap: 12px
    margin: 6px 0 18px

  &__search
    position: relative
    flex: 1 1 280px
    display: flex
    align-items: center

  &__search-ic
    position: absolute
    left: 15px
    font-size: 14px
    color: $muted
    pointer-events: none

  &__search-input
    width: 100%
    height: 48px
    border: 1px solid $line
    border-radius: 10px
    background: #fff
    padding: 0 42px 0 40px
    font-size: 15px
    font-family: Lato, sans-serif
    color: $ink
    outline: none
    transition: border-color .18s ease, box-shadow .18s ease
    &::placeholder
      color: rgba(92, 102, 115, 0.55)
    &:focus
      border-color: $blue
      box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.12)

  &__search-clear
    position: absolute
    right: 10px
    display: grid
    place-items: center
    width: 28px
    height: 28px
    border: none
    border-radius: 7px
    background: $mist
    color: $muted
    font-size: 12px
    cursor: pointer
    transition: background .15s ease, color .15s ease
    &:hover
      background: rgba(221, 52, 52, 0.10)
      color: $red

  &__select
    height: 48px
    border: 1px solid $line
    border-radius: 10px
    background: #fff
    padding: 0 14px
    font-size: 14px
    font-family: Lato, sans-serif
    color: $ink
    cursor: pointer
    outline: none
    transition: border-color .18s ease, box-shadow .18s ease
    &:focus
      border-color: $blue
      box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.12)

  &__count
    font-family: $mono
    font-size: 12px
    letter-spacing: 0.04em
    color: $muted
    margin: 0 0 12px

  // ---------- LINHAS COMPACTAS ----------
  &__rows
    display: flex
    flex-direction: column
    gap: 8px

  // ---------- ESTADO VAZIO DE FILTRO ----------
  &__empty-filter
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
    gap: 12px
    padding: 44px 24px
    background: $paper
    border: 1px dashed rgba(11, 14, 20, 0.18)
    border-radius: 14px
    color: $muted
    &-ic
      font-size: 28px
      color: $blue

  // ====================================================================
  // CARD GRANDE (destaque)
  // ====================================================================
  .fcard
    display: flex
    flex-direction: column
    background: $paper
    border: 1px solid $line
    border-radius: 16px
    padding: 20px 20px 18px
    box-shadow: 0 12px 30px rgba(11, 14, 20, 0.06)
    transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease
    animation: ff-rise .5s cubic-bezier(.2, .7, .2, 1) both
    &:hover
      transform: translateY(-3px)
      box-shadow: 0 20px 44px rgba(11, 14, 20, 0.12)
    &--live
      border-color: rgba(46, 158, 79, 0.45)
      box-shadow: 0 0 0 3px rgba(46, 158, 79, 0.10), 0 12px 30px rgba(11, 14, 20, 0.06)

    &__head
      display: flex
      align-items: center
      justify-content: space-between
      margin-bottom: 16px

    &__order
      display: inline-flex
      align-items: baseline
      gap: 7px
      small
        font-family: $mono
        text-transform: uppercase
        letter-spacing: 0.16em
        font-size: 10px
        font-weight: 700
        color: $muted
      strong
        font-family: $display
        font-size: 26px
        font-weight: 800
        line-height: 1
        color: $ink

    &__status
      font-family: $mono
      font-size: 10px
      font-weight: 700
      letter-spacing: 0.1em
      text-transform: uppercase
      padding: 5px 11px
      border-radius: 999px
      &.is-live
        background: rgba(46, 158, 79, 0.12)
        color: $green-dark
      &.is-done
        background: rgba(92, 102, 115, 0.14)
        color: $muted
      &.is-queued
        background: rgba(40, 122, 237, 0.12)
        color: $blue-dark
      &.is-wait
        background: rgba(221, 52, 52, 0.10)
        color: $red-dark

    &__match
      display: grid
      grid-template-columns: 1fr auto 1fr
      align-items: center
      gap: 10px

    &__side
      display: flex
      flex-direction: column
      align-items: center
      gap: 8px
      padding: 16px 10px
      border-radius: 12px
      min-width: 0
      width: 100%
      &--blue
        background: radial-gradient(circle at 50% 0%, rgba(40, 122, 237, 0.14), rgba(40, 122, 237, 0.04) 78%)
        box-shadow: inset 0 0 0 1px rgba(40, 122, 237, 0.22)
        .fcard__side-ic
          color: $blue
      &--red
        background: radial-gradient(circle at 50% 0%, rgba(221, 52, 52, 0.14), rgba(221, 52, 52, 0.04) 78%)
        box-shadow: inset 0 0 0 1px rgba(221, 52, 52, 0.22)
        .fcard__side-ic
          color: $red

    &__side-tag
      display: inline-flex
      align-items: center
      gap: 7px
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.1em
      font-size: 10px
      font-weight: 700
      color: $muted

    &__side-ic
      font-size: 13px

    &__side-name
      font-family: $display
      text-transform: uppercase
      font-weight: 700
      font-size: 19px
      line-height: 1.1
      text-align: center
      color: $ink
      max-width: 100%
      overflow-wrap: anywhere

    &__vs
      span
        display: grid
        place-items: center
        width: 44px
        height: 44px
        border-radius: 50%
        font-family: $display
        font-weight: 800
        font-size: 16px
        color: #fff
        background: $ink
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9), 0 6px 16px rgba(11, 14, 20, 0.30)

    &__meta
      display: flex
      flex-wrap: wrap
      gap: 8px
      margin-top: 16px
      padding-top: 16px
      border-top: 1px solid $line

    &__chip
      display: inline-flex
      align-items: center
      gap: 7px
      font-size: 13px
      font-weight: 600
      color: $ink
      background: $mist
      border-radius: 8px
      padding: 6px 11px
      &-ic
        font-size: 12px
        color: $blue

    &__action
      margin-top: 16px
    &__action-btn
      width: 100%
      justify-content: center

  // ====================================================================
  // LINHA COMPACTA (agenda completa / edição)
  // ====================================================================
  .frow
    display: grid
    grid-template-columns: 58px minmax(0, 1.7fr) minmax(0, 1.4fr) auto
    align-items: center
    gap: 14px
    background: $paper
    border: 1px solid $line
    border-radius: 12px
    padding: 12px 16px
    transition: border-color .18s ease, box-shadow .18s ease, transform .12s ease
    &:hover
      border-color: rgba(40, 122, 237, 0.30)
      box-shadow: 0 8px 22px rgba(11, 14, 20, 0.07)
    &--live
      border-color: rgba(46, 158, 79, 0.45)
      background: rgba(46, 158, 79, 0.04)
    &--done
      opacity: 0.6
    &--edit
      grid-template-columns: 58px minmax(0, 1.7fr) minmax(0, 1.4fr) auto

    &__order
      font-family: $display
      font-weight: 800
      font-size: 18px
      color: $ink
      white-space: nowrap

    &__match
      display: flex
      align-items: center
      gap: 9px
      min-width: 0
      flex-wrap: wrap

    &__robot
      font-family: $display
      text-transform: uppercase
      font-weight: 700
      font-size: 17px
      line-height: 1.1
      color: $ink
      overflow-wrap: anywhere
      padding-left: 10px
      &--blue
        box-shadow: inset 3px 0 0 $blue
      &--red
        box-shadow: inset 3px 0 0 $red

    &__x
      font-family: $mono
      font-size: 12px
      color: $muted
      flex-shrink: 0

    &__tags
      display: flex
      flex-wrap: wrap
      gap: 6px
      min-width: 0

    &__tag
      display: inline-flex
      align-items: center
      font-size: 12px
      font-weight: 600
      color: $blue-dark
      background: rgba(40, 122, 237, 0.10)
      border-radius: 7px
      padding: 4px 9px
      white-space: nowrap
      &--muted
        color: $muted
        background: $mist
      &--time
        gap: 6px
        color: $ink
        background: $mist
        font-family: $mono
        font-weight: 700

    &__tag-ic
      font-size: 11px
      color: $blue

    &__status
      justify-self: end
      font-family: $mono
      font-size: 10px
      font-weight: 700
      letter-spacing: 0.08em
      text-transform: uppercase
      padding: 5px 10px
      border-radius: 999px
      white-space: nowrap
      &.is-live
        background: rgba(46, 158, 79, 0.12)
        color: $green-dark
      &.is-done
        background: rgba(92, 102, 115, 0.14)
        color: $muted
      &.is-queued
        background: rgba(40, 122, 237, 0.12)
        color: $blue-dark
      &.is-wait
        background: rgba(221, 52, 52, 0.10)
        color: $red-dark

    &__action
      justify-self: end

    &__edit
      justify-self: end
      display: flex
      gap: 7px

    &__edit-btn
      display: grid
      place-items: center
      width: 38px
      height: 38px
      border: 1px solid $line
      border-radius: 9px
      background: #fff
      color: $ink
      font-size: 13px
      cursor: pointer
      transition: border-color .18s ease, background .18s ease, color .18s ease, transform .12s ease
      &:hover
        border-color: $blue
        color: $blue
        background: rgba(40, 122, 237, 0.06)
      &:active
        transform: scale(.94)

  // ---------- BOTÕES ----------
  .btn
    display: inline-flex
    align-items: center
    gap: 9px
    border: none
    cursor: pointer
    font-family: $display
    font-weight: 600
    text-transform: uppercase
    letter-spacing: 0.06em
    font-size: 15px
    padding: 0 22px
    height: 48px
    border-radius: 10px
    transition: transform .18s ease, box-shadow .18s ease, background .18s ease, border-color .18s ease
    &__ic
      font-size: 13px
    &--sm
      height: 40px
      padding: 0 16px
      font-size: 13px
    &--solid
      background: $blue
      color: #fff
      box-shadow: 0 10px 24px rgba(40, 122, 237, 0.32)
      &:hover
        background: $blue-dark
        transform: translateY(-2px)
        box-shadow: 0 14px 30px rgba(40, 122, 237, 0.42)
    &--ghost-dark
      background: #fff
      color: $ink
      border: 1px solid rgba(11, 14, 20, 0.18)
      &:hover
        border-color: $ink
        transform: translateY(-2px)

  // ---------- MODAL ----------
  .modal-content
    max-height: 60vh
    overflow-y: auto
    overflow-x: clip
    display: flex
    flex-direction: column
    align-items: stretch
    gap: 16px
    margin: 0
    padding: 40px 34px 34px
    width: 100%

    &__title
      font-family: $display
      text-transform: uppercase
      font-size: 23px
      font-weight: 700
      line-height: 1.1
      margin: 0
      text-align: center

    &__field
      display: flex
      flex-direction: column
      gap: 8px

    &__field-label
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.1em
      font-size: 11px
      font-weight: 700
      color: $muted

    &__input
      height: 50px
      padding: 0 14px
      border: 1px solid $line
      border-radius: 10px
      background: #fff
      font-size: 15px
      color: $ink
      font-family: Lato, sans-serif
      outline: none
      transition: border-color .18s ease, box-shadow .18s ease
      &:focus
        border-color: $blue
        box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.12)

    &__select
      margin: 0

    &__note
      font-size: 13.5px
      line-height: 1.5
      color: $muted
      margin: 0
      text-align: center

    &__note--strong
      color: $ink
      font-weight: 700

    &__confirm
      width: 100%
      justify-content: center
      margin-top: 4px

@keyframes ff-rise
  from
    opacity: 0
    transform: translateY(16px)
  to
    opacity: 1
    transform: none

@keyframes ff-pulse
  0%
    box-shadow: 0 0 0 0 rgba(46, 158, 79, 0.5)
  70%
    box-shadow: 0 0 0 9px rgba(46, 158, 79, 0)
  100%
    box-shadow: 0 0 0 0 rgba(46, 158, 79, 0)

// ---------- responsivo ----------
@media (max-width: 720px)
  .fights__hero
    padding: 38px 0 50px
  .fights__hero-inner
    padding: 0 18px
  .fights__wrap
    padding: 0 18px 56px
  .fights__toolbar
    flex-direction: column
    align-items: stretch
  .fights__toolbar-actions
    margin-left: 0
  .fights .btn
    flex: 1
    justify-content: center
  // linha compacta vira bloco empilhado no mobile
  .fights .frow
    grid-template-columns: 1fr auto
    grid-template-areas: "order status" "match match" "tags tags" "action action"
    gap: 10px
  .fights .frow--edit
    grid-template-columns: 1fr auto
    grid-template-areas: "order edit" "match match" "tags tags"
  .fights .frow__order
    grid-area: order
  .fights .frow__status
    grid-area: status
  .fights .frow__match
    grid-area: match
  .fights .frow__tags
    grid-area: tags
  .fights .frow__action
    grid-area: action
    justify-self: stretch
  .fights .frow__action .btn
    width: 100%
  .fights .frow__edit
    grid-area: edit
</style>
